import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'

function ExpandButton({ classes, expand, onExpand }) {
  return (
    <IconButton
      className={`${classes.iconShow} ${!expand ? classes.iconNotShow : ''}`}
      onClick={onExpand}
    >
      <ExpandMore />
    </IconButton>
  )
}

ExpandButton.propTypes = {
  expand: PropTypes.bool,
  onExpand: PropTypes.func,
}

ExpandButton.defaultProps = {
  expand: true,
  onExpand: () => true
}

const styles = theme => ({
  iconShow: {
    transform: 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  iconNotShow: {
    transform: 'rotate(0deg)',
  },
})

export default withStyles(styles)(ExpandButton)